export default {
    baseStyle: (props) => ({
        heading: {
            lineHeight: '24px',
            minHeight: '56px',
            padding: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        closeButton: {
            cursor: 'pointer'
        },
        leftArrowButton: {
            padding: 0,
            height: 'auto',
            minWidth: 'auto',
            _hover: {
                backgroundColor: 'white'
            }
        },
        stickyHeader: {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: 'white',
            width: '100%'
        },
        catHeading: {
            textStyle: 'webH2'
        },
        navDivider: {
            borderColor: 'webTheme.strokeTertiary',
            margin: '20px 16px',
            maxWidth: 'stretch'
        },
        navFooterWrapper: {
            flexDirection: 'column',
            gap: 6,
            paddingLeft: 4,
            paddingRight: 4
        },
        navFooterButton: {
            variant: 'unstyled',
            textStyle: 'bodyMdRegular',
            height: 'auto',
            minHeight: 'auto'
        },
        navFooterLinkContainer: {
            gap: 2
        },
        navFooterIcon: {
            width: '20px',
            height: '20px'
        },
        navFooterLink: {
            textStyle: 'bodyMdRegular'
        },
        brandSelectorWrapper: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            padding: '0 16px 16px',
            width: '100%'
        },
        brandSelectorLabel: {
            textStyle: 'bodySmRegular',
        },
        brandSelectorLink: {
            display: 'inline-flex',
            justifyContent: 'start'
        },
        brandSelectorLogo: {
            height: '16px'
        }
    }),
    nestedCategory: {
        navTab: {
            textStyle: 'labelMdSm',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            width: '100%',
            backgroundColor: 'white',
            height: 'auto',
            paddingTop: '10px',
            paddingBottom: '10px',
            paddingLeft: 4,
            paddingRight: 4,
            _hover: {
                backgroundColor: 'white'
            },
            _focusVisible: {
                margin: '3px',
                boxShadow: 'var(--chakra-shadows-outline)'
            },
            color: 'red'
        },
        navName: {
            textStyle: 'labelMdSm',
            textTransform: 'capitalize',
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            textAlign: 'left',
        },
        navLink: {
            textStyle: 'labelMdSm',
            flex: 1,
            textAlign: 'left',
            textTransform: 'capitalize',
            textDecoration: 'none',
            _hover: {
                textDecoration: 'none'
            },
            _active: {
                textDecoration: 'none'
            },
            _focusVisible: {
                margin: '3px',
                boxShadow: 'var(--chakra-shadows-outline)'
            },
        },
        arrowIcon: {
            transform: 'rotate(270deg)',
            width: '14px',
            height: '14px'
        }
    },
    parts: []
}
